import React from 'react';
import BaseModal from '../baseModal';
import './style.scss'

const BnsWarningModal = ({ show, close }) => {
    return (
        <BaseModal show={show} handleClose={close} title={''}>
            <p id='bns-warning'>This Requires a Name (BNS) for.</p>
            <ul id='bnsul'>
                <li>Redundancy in File Discovery</li>
                <li>Flexability in File Storage</li>
            </ul>
            <div className="broadcast-modal-tx__buttons">
                <button className="button" onClick={() => window.open("https://btc.us", "_blank")}>Get Name</button>
            </div>
        </BaseModal>
    )
}

export default BnsWarningModal;